<template>
  <transition name="fade">
    <div id="login-model-wrapper" v-show="modelShow" :key="getrans">
      <div class="login-model">
        <i
          @click="
            modelShow = false;
            showOtpMethodSelection = false;
            otp_panel_showing = false;
            showPasskeySection = false;
          "
          class="fa fa-times"
          aria-hidden="true"
        ></i>

        <div class="tab-buttons">
          <div
            @click="
              !otp_panel_showing
                ? ((toggle_tab = 'signin'),
                  (showOtpMethodSelection = false),
                  (showPasskeySection = false))
                : null
            "
            :class="toggle_tab === 'signin' ? `active` : ``"
          >
            {{ brandText.signIn }}
          </div>
          <div
            @click="
              !otp_panel_showing
                ? ((toggle_tab = 'create'),
                  (showOtpMethodSelection = false),
                  (showPasskeySection = false))
                : null
            "
            :class="toggle_tab === 'create' ? `active` : ``"
          >
            {{ brandText.createAccount }}
          </div>
        </div>

        <div class="content" v-show="toggle_tab === 'signin'">
          <template v-if="!otp_panel_showing">
            <div>
              <p>
                {{
                  brandText.signInIntro
                }}
              </p>
              <p>
                <b>{{
                  brandText.guestBookingInfo
                }}</b>
              </p>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${loginemail ? 'hasValue tick' : ''} ${
                  errors.loginemail ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="loginemail"
                  v-model="loginemail"
                  placeholder="Ex. johnsmith@example.com"
                  @blur="validateEmail('loginemail')"
                />
                <label for="loginemail"
                  >{{ brandText.emailAddress }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.loginemail" class="error-message">
                  {{ errors.loginemail ? brandText[errors.loginemail] || getrans(errors.loginemail) : '' }}
                </div>
              </div>
            </div>
            <div style="clear: both"></div>
            <div v-if="showOtpMethodSelection" class="otp-method-selection">
              <p style="text-align: center; font-weight: bold">
                {{ brandText.chooseOtpMethod }}
              </p>
              <div class="method-buttons">
                <button @click="selectOtpMethod('email')" class="proceed">
                  <i class="fa fa-envelope"></i>&nbsp;&nbsp;
                  {{ brandText.sendToEmail }}
                </button>
                <button @click="selectOtpMethod('sms')" class="proceed">
                  <i class="fa fa-mobile"></i>&nbsp;&nbsp;
                  {{ brandText.sendToMobile }}
                </button>
              </div>
            </div>
            <div class="login-buttons" v-if="!showOtpMethodSelection">
              <button
                v-if="!showLoginRegistration"
                @click="handleLogin('otp')"
                class="proceed"
                :disabled="loginSubmitting || showOtpMethodSelection"
              >
                <span v-if="loginSubmitting && !showOtpMethodSelection">
                  <i class="fa fa-spinner fa-spin"></i
                  >&nbsp;&nbsp;{{ brandText.checking }}
                </span>
                <span v-else>{{ brandText.signIn }}</span>
              </button>

              <!-- Login with Device button -->
              <WebAuthnLogin
                v-if="!showLoginRegistration"
                :username="loginemail"
                :brand_id="setbrandid"
                @login-complete="handleLoginSuccess"
                @login-error="onLoginError"
                @fetch-user-details="handlePostLoginFlow"
              />

              <div
                v-if="showLoginRegistration"
                class="login-registration-fallback"
              >
                <div v-if="!passkeyEmailVerified" class="info-message">
                  <i class="fa fa-info-circle"></i>
                  <p>
                    {{
                      brandText.passkey
                    }}
                  </p>
                </div>
                
                <!-- Email Verification Step -->
                <div v-if="!passkeyEmailVerified" class="email-verification">
                  <div v-if="!passkeyOtpSent">
                    <p>{{ brandText.pleaseVerifyEmail }}</p>
                    <button @click="sendLoginPasskeyVerificationOtp" class="verify-email-btn">
                      {{ brandText.sendVerificationCode }}
                    </button>
                  </div>
                  <div v-else>
                    <p>{{ brandText.enterVerificationCode }}</p>
                    <input
                      type="text"
                      v-model="passkeyOtpCode"
                      placeholder="Enter 6-digit code"
                      maxlength="6"
                      class="otp-input"
                    />
                    <button @click="verifyLoginPasskeyEmail" class="verify-code-btn">
                      {{ brandText.verifyCode }}
                    </button>
                  </div>
                </div>
                
                <!-- Verification Success Message -->
                <div v-if="passkeyEmailVerified" class="verification-success">
                  <div class="success-message">
                    <i class="fa fa-check-circle"></i>
                    <p>{{ brandText.emailVerificationSuccess }}</p>
                  </div>
                </div>
                
                <WebAuthnRegister
                  v-if="passkeyEmailVerified"
                  :username="loginemail"
                  :brand_id="setbrandid"
                  @registration-complete="onLoginRegistrationComplete"
                />
                <button
                  @click="showLoginRegistration = false; resetPasskeyVerification()"
                  class="back-to-login"
                >
                  {{ brandText.backToLogin }}
                </button>
              </div>
            </div>
          </template>

          <template v-else>
            <p>
              {{
                brandText.verificationSent
              }}
            </p>
            <div v-if="showCrossDeviceOption" class="cross-device-option">
              <p>
                {{ brandText.continueOnPhone }}
              </p>
              <button @click="generateCrossDeviceLink" class="cross-device-btn">
                <i class="fa fa-mobile"></i>&nbsp;&nbsp;
                {{ brandText.continueOnPhoneBtn }}
              </button>
            </div>
            <OTPInput
              v-on:opt_change="opt_change"
              :otpLength="6"
              :autocomplete="otpSentMethod === 'sms' ? 'one-time-code' : ''"
              :inputmode="'numeric'"
              ref="otpInput"
            />
            <RememberDeviceComponent
              v-if="false"
              v-model="rememberDevice"
              :getransfn="getrans"
            />
            <p>
              {{ brandText.didNotGetCode }}&nbsp;
              <!-- <a href="#" @click.prevent="reloadPage">{{ brandText.tryAgain }}</a> -->
              <a href="#" @click.prevent="otp_panel_showing = false">{{ brandText.tryAgain }}</a>
              
            </p>
            <!-- <button @click="handleLogin('verify')" class="proceed">
              {{ brandText.signIn }}
            </button> -->

            <button
              type="button"
              @click="handleLogin('verify')"
              class="proceed"
              :disabled="formSubmitting"
            >
              <span v-if="formSubmitting"
                ><i class="fa fa-spinner fa-spin"></i
                >&nbsp;&nbsp;{{ brandText.signingIn }}</span
              >
              <span v-else>{{ brandText.signIn }}</span>
            </button>
          </template>
        </div>

        <div class="content" v-show="toggle_tab === 'create'">
          <template v-if="!otp_panel_showing && !showPasskeySection">
            <div 
              class="content-box" 
              v-if="
                brandText.createAccountIntro || 
                brandText.loyaltyMember ||
                brandText.unlockPerks || 
                brandText.redeemPoints
              ">
              <p>
                <b>{{ brandText.createAccountIntro }}</b>
              </p>
              <ul>
                <li>{{ brandText.loyaltyMember }}</li>
                <li>{{ brandText.unlockPerks }}</li>
                <li>
                  {{ brandText.redeemPoints }}
                </li>
              </ul>
            </div>
            <div v-else><br></div>

            <h3>{{ brandText.yourDetails }}</h3>
            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${firstname ? 'hasValue tick' : ''} ${
                  errors.firstname ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="firstname"
                  v-model="firstname"
                  placeholder="Ex. John"
                  @blur="validateField('firstname')"
                />
                <label for="firstname"
                  >{{ brandText.firstName }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.firstname" class="error-message">
                  {{ errors.firstname ? brandText[errors.firstname] || getrans(errors.firstname) : '' }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${surname ? 'hasValue tick' : ''} ${
                  errors.surname ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="lastname"
                  v-model="surname"
                  placeholder="Ex. Smith"
                  @blur="validateField('surname')"
                />
                <label for="surname"
                  >{{ brandText.lastName }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.surname" class="error-message">
                  {{ errors.surname ? brandText[errors.surname] || getrans(errors.surname) : '' }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${email ? 'hasValue tick' : ''} ${
                  errors.email ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="email"
                  v-model="email"
                  placeholder="Ex. johnsmith@example.com"
                  @blur="validateEmail('email')"
                />
                <label for="email"
                  >{{ brandText.emailAddress }}<span class="form-mandatory">*</span></label
                >
                <div v-if="errors.email" class="error-message">
                  {{ errors.email ? brandText[errors.email] || getrans(errors.email) : '' }}
                </div>
              </div>
            </div>

            <p
              style="
                color: #e00b27;
                display: block;
                width: 100%;
                text-align: center;
                font-weight: bold;
              "
            >
              {{ brandText.noPassword }}
            </p>

            <div class="block-wrap" style="width: 100%">
              <div
                class="input-checkbox"
                :class="`${errors.term_condition ? 'error' : ''}`"
              >
                <input
                  class="checkmark-style"
                  type="checkbox"
                  name="term_condition"
                  v-model="term_condition"
                  id="term_condition"
                  @change="validateField('term_condition')"
                />
                <label for="term_condition">
                  {{ brandText.acceptTermsPrefix }}&nbsp;<a target="_blank" :href="brandText.terms_and_conditions_link">{{
                    brandText.termsAndConditions
                  }}</a>&nbsp;{{ brandText.acceptTermsSuffix }}
                </label>
                <div v-if="errors.term_condition" class="error-message">
                  {{ errors.term_condition ? brandText[errors.term_condition] || getrans(errors.term_condition) : '' }}
                </div>
              </div>
            </div>

            <div class="block-wrap" style="width: 100%">
              <div class="input-checkbox">
                <input
                  class="checkmark-style"
                  type="checkbox"
                  name="email_consent"
                  v-model="email_consent"
                  value="0"
                  id="email_consent"
                />
                <label for="email_consent_disabled">
                  {{ brandText.optInPrefix }}&nbsp;<a target="_blank" :href="brandText.privacy_policy_link">
                    {{ brandText.privacyNoticeLinkText }}
                  </a>&nbsp;{{ brandText.optInSuffix }}
                </label>
              </div>
            </div>
            <div style="clear: both"></div>
            <button
              type="button"
              @click="handleLogin('create')"
              class="proceed"
              :disabled="formSubmitting"
              style="margin-top: 1rem;"
            >
              <span v-if="formSubmitting"
                ><i class="fa fa-spinner fa-spin"></i
                >&nbsp;&nbsp;{{ brandText.creatingAccount }}</span
              >
              <span v-else>{{ brandText.createAccount }}</span>
            </button>
          </template>

          <template v-else-if="!showPasskeySection">
            <p>
              {{
                brandText.verificationSent
              }}
            </p>
            <OTPInput v-on:opt_change="opt_change" :otpLength="6" />
            <RememberDeviceComponent v-model="rememberDevice" :getransfn="getrans"/>
            <p>
              {{ brandText.didNotGetCode }}&nbsp;
              <!-- <a href="#" @click.prevent="reloadPage">{{ brandText.tryAgain }}</a> -->
              <a href="#" @click.prevent="otp_panel_showing = false">{{ brandText.tryAgain }}</a>
            </p>
            <button @click="handleLogin('verify')" class="proceed" :disabled="formSubmitting">
              <span v-if="formSubmitting">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;{{ brandText.signingIn }}
              </span>
              <span v-else>{{ brandText.signIn }}</span>
            </button>
          </template>

          <template v-else>

            <br>

            <div style="margin-bottom: 15px; text-align: center; font-size: 1rem; width: 80%; margin-left: auto; margin-right: auto;">
              <span >{{ brandText.passkeyInfo }}</span>
            </div>

            <br>

            <div class="block-wrap" style="width: 100%">
              <div
                class="block"
                :class="`${regUsername ? 'hasValue tick' : ''} ${
                  errors.regUsername ? 'error' : ''
                }`"
              >
                <input
                  type="text"
                  id="regUsername"
                  v-model="regUsername"
                  placeholder="Ex. johnsmith@example.com"
                  @blur="validateEmail('regUsername')"
                  :disabled="passkeyEmailVerified"
                />
                <label for="regUsername"
                  >Email Address:</label
                >
                <div v-if="errors.regUsername" class="error-message">
                  {{ errors.regUsername ? brandText[errors.regUsername] || getrans(errors.regUsername) : '' }}
                </div>
              </div>
            </div>

            <div style="clear: both"></div>

              <div class="divider">
              
              </div>


            <div class="passkey-section">
            


             


              <!-- <div class="form-group">
                <label for="regUsername">Email Address:</label>
                <input
                  type="text"
                  id="regUsername"
                  v-model="regUsername"
                  placeholder="Ex. johnsmith@example.com"
                  @blur="validateEmail('regUsername')"
                  :disabled="passkeyEmailVerified"
                />
                <div v-if="errors.regUsername" class="error-message">
                  {{ errors.regUsername ? brandText[errors.regUsername] || errors.regUsername : '' }}
                </div>
              </div> -->

              <!-- Email Verification Step -->
              <div v-if="!passkeyEmailVerified && regUsername && !errors.regUsername" class="email-verification">
                <div v-if="!passkeyOtpSent">
                  <p>{{ brandText.pleaseVerifyEmail }}</p>
                  <button @click="sendPasskeyVerificationOtp" class="verify-email-btn">
                    {{ brandText.sendVerificationCode }}
                  </button>
                </div>
                <div v-else>
                  <p>{{ brandText.enterVerificationCode }}</p>
                  <input
                    type="text"
                    v-model="passkeyOtpCode"
                    placeholder="Enter 6-digit code"
                    maxlength="6"
                    class="otp-input"
                  />
                  <button @click="verifyPasskeyEmail" class="verify-code-btn">
                    {{ brandText.verifyCode }}
                  </button>
                </div>
              </div>
              
              <!-- Verification Success Message -->
              <div v-if="passkeyEmailVerified && !registrationSuccessful" class="verification-success">
                <div class="success-message">
                  <i class="fa fa-check-circle"></i>
                  <p>{{ brandText.emailVerificationSuccess }}</p>
                </div>
              </div>
              <WebAuthnRegister
                v-if="passkeyEmailVerified && !registrationSuccessful"
                :username="regUsername"
                :brand_id="setbrandid"
                @registration-complete="onRegistrationComplete"
                :class="tester"
              />
              <div v-if="registrationSuccessful" class="registration-success">
                <div class="success-message">
                  <i class="fa fa-check-circle"></i>
                  <h4>{{ brandText.registrationSuccessTitle }}</h4>
                  <p>
                    {{
                      brandText.registrationSuccessMessage
                    }}
                  </p>
                </div>
              </div>

              <button
                @click="(modelShow = false)" 
                class="proceed"
                v-if="passkeyEmailVerified || registrationSuccessful"
              >
                {{ brandText.continue }}
              </button>
              <button
                @click="(modelShow = false)" 
                class="skip-passkey"
                v-if="!passkeyEmailVerified && !registrationSuccessful"
              >
                {{ brandText.skipForNow }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import OTPInput from "./OTPInput.vue";
import RememberDeviceComponent from "./RememberDeviceComponent.vue";
import WebAuthnLogin from "./webauthn/WebAuthnLogin.vue";
import WebAuthnRegister from "./webauthn/WebAuthnRegister.vue";
import apiProxy from '@/services/apiProxy';
import Swal from "sweetalert2";
import loginContent from "@/brand/brand.login_content.js";
import { normalizeBrandId } from '@/modules/brandId';
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");

export default {
  name: "LoginModelNew",
  props: {
    setbrandid: {
      type: String,
      required: false
    },
    getransfn: {
      type: Function,
      required: false
    },
    lang: {
      type: String,
      required: false,
      default: 'EN'
    }
  },
  components: {
    OTPInput,
    RememberDeviceComponent,
    WebAuthnLogin,
    WebAuthnRegister,
  },

  data() {
    return {
      modelShow: false,
      otp_panel_showing: false,
      toggle_tab: "signin",
      loginemail: "",
      regUsername: "",
      firstname: "",
      surname: "",
      email: "",
      password: "",
      term_condition: false,
      email_consent: false,
      rememberDevice: false,
      loginSubmitting: false,
      formSubmitting: false,
      registrationSuccessful: false,
      showLoginRegistration: false,
      showOtpMethodSelection: false,
      selectedOtpMethod: null,
      pendingLoginData: null,
      otpSentMethod: null,
      showPasskeySection: false,
      passkeyEmailVerified: false,
      passkeyOtpSent: false,
      passkeyOtpCode: "",
      passkeySessionToken: null,
      // Web OTP specific
      webOtpSupported: false,
      webOtpController: null,
      showCrossDeviceOption: false,
      crossDeviceSessionId: null,
      orderreference: null,
      terms_and_conditions_link: "",
      privacy_policy_link: "",
      currentRequestId: null,
      errors: {
        loginemail: null,
        regUsername: null,
        firstname: null,
        surname: null,
        email: null,
        term_condition: null,
      },
    };
  },

  computed: {
    hasValidationErrors() {
      return (
        this.errors.firstname ||
        this.errors.surname ||
        this.errors.email ||
        this.errors.term_condition ||
        !this.firstname ||
        !this.surname ||
        !this.email ||
        !this.term_condition
      );
    },
    brandText() {
      const content = encodeHTMLEntities(loginContent[this.setbrandid]);
      //console.log('content',content);
      // function decodeHTMLEntities(str) {
      //   if (typeof str !== 'string') return str;
      //   const txt = document.createElement('textarea');
      //   txt.innerHTML = str;
      //   return txt.value;
      // }
      // Helper to encode HTML entities (for comparison)
      function encodeHTMLEntities(str) {
        if (typeof str !== 'string') return str;
        const txt = document.createElement('textarea');
        txt.textContent = str;
        return txt.innerHTML
          .replace(/'/g, '&#39;')
          .replace(/"/g, '&quot;');
      }



      // Map each key to its translated value
      const translated = {};
      for (const key in content) {
        let result = this.getrans(content[key]).replace(/&amp;/g, '&');
        // Hard-coded fix for Terms & Conditions in German
        if (this.lang === 'DE' && content[key] === 'Terms & Conditions') {
          result = 'Buchen Sie Ihre';
          console.log('keyyy',key +"==="+ content[key]+"===="+result);
        }
        
        translated[key] = result;
      }
      return translated;
    }
  },

  methods: {

    getrans(key) {
      if (this.getransfn && typeof this.getransfn === 'function') {
        return this.getransfn(key);
      }
      return key; // Fallback: return the key itself if no function provided
    },

    reloadPage() {
      window.location.reload();
    },

    opt_change(value) {
      this.password = value;
    },

    // Web OTP Detection
    checkWebOtpSupport() {
      this.webOtpSupported =
        "OTPCredential" in window &&
        "navigator" in window &&
        "credentials" in navigator;
      return this.webOtpSupported;
    },

    // Web OTP Implementation
    async requestWebOtp() {
      if (!this.webOtpSupported || this.otpSentMethod !== "sms") return;

      try {
        this.webOtpController = new AbortController();

        const credential = await navigator.credentials.get({
          otp: { transport: ["sms"] },
          signal: this.webOtpController.signal,
        });

        if (credential && credential.code) {
          this.password = credential.code;
          // Auto-trigger verification
          await this.handleLogin("verify");
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Web OTP request aborted");
        } else if (error.name === "NotSupportedError") {
          console.log("Web OTP not supported");
        } else {
          console.error("Web OTP error:", error);
        }
      }
    },

    // Cross-device OTP
    generateCrossDeviceSessionId() {
      return crypto.randomBytes(16).toString("hex");
    },

    generateCrossDeviceLink() {
      this.crossDeviceSessionId = this.generateCrossDeviceSessionId();
      const baseUrl = window.location.origin;
      const crossDeviceUrl = `${baseUrl}/verify-otp?session=${this.crossDeviceSessionId}`;

      // Store session data for cross-device verification
      sessionStorage.setItem(
        `cross_device_${this.crossDeviceSessionId}`,
        JSON.stringify({
          email: this.loginemail,
          uuid: this.pendingLoginData?.uuid,
          timestamp: Date.now(),
        })
      );

      // Open URL or show QR code
      if (navigator.share) {
        navigator.share({
          title: "Continue Login",
          url: crossDeviceUrl,
        });
      } else {
        window.open(crossDeviceUrl, "_blank");
      }
    },

    // Handle deep link OTP
    handleDeepLinkOtp() {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get("session");
      const otpCode = urlParams.get("otp");

      if (sessionId && otpCode) {
        const sessionData = sessionStorage.getItem(`cross_device_${sessionId}`);
        if (sessionData) {
          const data = JSON.parse(sessionData);
          // Verify timestamp (expire after 10 minutes)
          if (Date.now() - data.timestamp < 600000) {
            this.password = otpCode;
            this.loginemail = data.email;
            this.pendingLoginData = { uuid: data.uuid };
            this.handleLogin("verify");
          }
          sessionStorage.removeItem(`cross_device_${sessionId}`);
        }
      }
    },

    normalizeEmail(value) {
      return (value || "").trim();
    },

    // Unified email validation
    validateEmail(field) {
      this.errors[field] = null;
      const value = this.normalizeEmail(this[field]);
      this[field] = value;

      if (!value) {
        this.errors[field] = "Email is required";
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(value)) {
        this.errors[field] = "Please enter a valid email address";
        return false;
      }

      // Reset passkey email verification if email changes
      if (field === "regUsername") {
        this.passkeyEmailVerified = false;
        this.passkeyOtpSent = false;
        this.passkeyOtpCode = "";
      }

      return true;
    },

    // Unified field validation
    validateField(field) {
      this.errors[field] = null;

      switch (field) {
        case "firstname":
        case "surname":
          if (!this[field]) {
            this.errors[field] = `${
              field === "firstname" ? "First" : "Last"
            } name is required`;
            return false;
          }
          break;
        case "term_condition":
          if (!this.term_condition) {
            this.errors[field] = "You must accept the Terms & Conditions";
            return false;
          }
          break;
      }
      return true;
    },

    // Unified login handler
    async handleLogin(type) {
      try {
        switch (type) {
          case "otp":
            await this.handleOTPLogin();
            break;
          case "verify":
            await this.handleOTPVerification();
            break;
          case "create":
            await this.handleAccountCreation();
            break;
        }
      } catch (error) {
        console.error(`${type} login error:`, error);
        this.showError("An error occurred. Please try again.");
      }
    },

    async handleOTPLogin() {
      if (!this.validateEmail("loginemail")) return;

      this.loginSubmitting = true;
      const isValid = await this.checkUserForLogin(this.loginemail);

      if (!isValid) {
        this.errors.loginemail = "An error as occured , please contact site administrator";
        this.showError(this.errors.loginemail);
        this.loginSubmitting = false;
        return;
      }

      // Only show OTP panel if method selection is not shown
      if (!this.showOtpMethodSelection) {
        this.otp_panel_showing = true;
        this.loginSubmitting = false;

        // Initialize Web OTP for SMS
        if (this.otpSentMethod === "sms") {
          this.requestWebOtp();
          this.showCrossDeviceOption = !this.webOtpSupported;
        }
      }
    },

    async handleOTPVerification() {
      if (!this.password) {
        this.showError("Please enter valid code.");
        return;
      }
      this.formSubmitting = true;

      // Cancel Web OTP request if active
      if (this.webOtpController) {
        this.webOtpController.abort();
        this.webOtpController = null;
      }

      let response;
      if (this.otpSentMethod === "sms") {
        const device_id = this.genHash(this.loginemail || this.email);
        response = await this.verifyMobileOTP(this.password, device_id);
      } else {
        const emailentered =
          this.toggle_tab === "signin" ? this.loginemail : this.email;
        response = await this.verifyOTP(emailentered, this.password);
      }

      if (response.success) {
        // Small delay to ensure server-side session update is complete
        await new Promise(resolve => setTimeout(resolve, 100));
        await this.handlePostLoginFlow();
      } else {
        this.showError("Invalid code. Please try again.");
        this.formSubmitting = false;
      }
    },

    async handleAccountCreation() {
      const isValid = await this.validateRegistrationForm();
      if (!isValid) return;

      this.formSubmitting = true;
      const response = await this.createUserAccount();

      if (response.success) {
        await this.sendOtp(this.email);
        this.otp_panel_showing = true;
        this.otpSentMethod = "email";
      }
      this.formSubmitting = false;
    },

    async validateRegistrationForm() {
      const fields = ["firstname", "surname", "email", "term_condition"];
      let isValid = true;

      fields.forEach((field) => {
        if (field === "email") {
          if (!this.validateEmail(field)) isValid = false;
        } else {
          if (!this.validateField(field)) isValid = false;
        }
      });

      if (isValid) {
        const exists = await this.checkUserExists(this.email);
        if (exists) {
          this.errors.email = "This email is already registered";
          return false;
        }
      }

      return isValid;
    },

    // Unified post-login flow
    async handlePostLoginFlow() {
      try {
        // After successful OTP verification, session is updated server-side
        // Force a session refresh to ensure we have the latest session data
        console.log('[LoginModelNew] Refreshing session after successful OTP verification');
        await apiProxy.initializeSession();
        
        const expectedEmail = (this.loginemail || this.email || "").toLowerCase().trim();
        const userDetails = await this.fetchUserDetails(this.loginemail || this.email);

        if (userDetails.user_exists === "Y") {
          const records = Array.isArray(userDetails.result) ? userDetails.result : [];
          const selectedUser = records.find(
            (row) => (row?.email || "").toLowerCase().trim() === expectedEmail
          ) || records[0];
          if (!selectedUser) {
            throw new Error("No matching user record found for current session");
          }
          this.updateUserData(selectedUser);
          await this.enw_log();

          // Handle remember device
          if (this.rememberDevice) {
            await this.handleRememberDevice();
          }

          // Show passkey section only if coming from create account flow
          if (this.toggle_tab === "create") {
            console.log("DEBUG: Setting passkey section - toggle_tab:", this.toggle_tab);
            console.log("DEBUG: Before - otp_panel_showing:", this.otp_panel_showing, "showPasskeySection:", this.showPasskeySection);
            this.showPasskeySection = true;
            this.otp_panel_showing = false;
            this.formSubmitting = false;
            // Pre-fill with verified email and mark as verified
            this.regUsername = this.email;
            this.passkeyEmailVerified = true;
            console.log("DEBUG: After - otp_panel_showing:", this.otp_panel_showing, "showPasskeySection:", this.showPasskeySection);
            console.log("DEBUG: formSubmitting:", this.formSubmitting);
            console.log("DEBUG: regUsername:", this.regUsername, "passkeyEmailVerified:", this.passkeyEmailVerified);
          } else {
            this.modelShow = false;
            // Dispatch event to update header without page reload
            console.log('[LoginModelNew] Dispatching userLoggedIn event for header update');
            window.dispatchEvent(new CustomEvent("userLoggedIn"));
          }
        } else {
          this.showError("An error as occured , please contact site administrator");
        }
      } catch (error) {
        console.error("Post-login flow error:", error);
        this.showError("Error fetching user details");
      }
    },

    async handleRememberDevice() {
      try {
        console.log("[DEBUG] handleRememberDevice called");
        console.log("[DEBUG] handleRememberDevice email:", this.loginemail || this.email);
        
        const RememberDevice = (await import("@/modules/RememberDevice"))
          .default;
        await RememberDevice.rememberDevice(null, this.loginemail || this.email);
      } catch (error) {
        console.error("Remember device error:", error);
      }
    },

    // WebAuthn event handlers
    async handleLoginSuccess(authToken) {
      // Call post-login flow to fetch user details and update session
      await this.handlePostLoginFlow();
      this.$emit("webauthn-login-success", authToken);
    },

    onLoginError(error) {
      console.error("error", error);
      
      // Check if it's a rate limiting error
      if (error && error.includes && error.includes('Rate limit exceeded')) {
        this.showError(error);
        return;
      }
      
      // Check if it's an account locked error
      if (error && error.includes && error.includes('Account temporarily locked')) {
        this.showError(error);
        return;
      }
      
      // For other errors, show registration fallback
      this.resetPasskeyVerification();
      this.showLoginRegistration = true;
    },

    onRegistrationComplete() {
      this.registrationSuccessful = true;
      this.$emit("webauthn-registration-success", this.regUsername);
    },

    onLoginRegistrationComplete() {
      this.showLoginRegistration = false;
      this.modelShow = false;
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "Your passkey has been registered. You can now login.",
        confirmButtonColor: "#034a94",
      });
    },

    // API calls
    async checkUserExists(email) {
      return this.makeUserCheckRequest(email, false);
    },

    async checkUserForLogin(email) {
      const result = await this.makeUserCheckRequest(email, true);
      if (result.valid && result.msg) {
        const normalizedBrand = String(normalizeBrandId(this.setbrandid) || "")
          .trim()
          .toUpperCase();
        const forceEmailForSb2 = normalizedBrand === "SB2";
        const forceEmailForSt1 = normalizedBrand === "ST1";

        if (forceEmailForSb2 || forceEmailForSt1) {
          console.log("DEBUG: Forcing email OTP for brand", {
            setbrandid: this.setbrandid,
            normalizedBrand,
            forceEmailForSb2,
            forceEmailForSt1,
          });
          this.showOtpMethodSelection = false;
          await this.sendOtp(email);
          this.otpSentMethod = "email";
          return result.valid;
        }

        if (result.msg.send_sms === "true" && result.msg.send_email === "true") {
          // Show user choice between SMS and Email
          this.pendingLoginData = { email };
          this.showOtpMethodSelection = true;
          return result.valid;
        } else if (result.msg.send_sms === "true") {
          await this.sendMobileOtp();
          this.otpSentMethod = "sms";
        } else {
          await this.sendOtp(email);
          this.otpSentMethod = "email";
        }
      }
      return result.valid;
    },

    async makeUserCheckRequest(email, forLogin = false) {
      try {
        const response = await apiProxy.call("Central Email Verification", {
          brand_id: normalizeBrandId(this.setbrandid),
          email_id: email,
        });

        const code = response.code?.toString();
        const userExists = code === "1" && response.data?.user_exists === "Y";

        if (forLogin) {
          return {
            valid: userExists,
            msg: response.data,
            // UUID removed - handled server-side for PCI compliance
          };
        } else {
          if (code === "1") return userExists;
          if (code === "37") return false;
          return false;
        }
      } catch (error) {
        return false;
      }
    },

    async sendOtp(email) {
      return await apiProxy.call("Central Email OTP Send", {
        brand_id: normalizeBrandId(this.setbrandid),
        email_id: email,
        language: this.lang.toUpperCase(),
      });
    },

    async sendMobileOtp() {
      return await apiProxy.call("Central Mobile OTP Send", {
        brand_id: normalizeBrandId(this.setbrandid),
        // UUID removed - Central Lambda will inject server-side
      });
    },

    async verifyMobileOTP(otp, device_id) {
      try {
        this.currentRequestId = this.generateRequestId();
        const response = await apiProxy.call("Central OTP Verify", {
          device_id: device_id,
          otp_code: otp,
          brand_id: normalizeBrandId(this.setbrandid),
          request_id: this.currentRequestId,
          // UUID removed - Central Lambda handles server-side
        });

        // Validate response matches request to prevent manipulation
        if (response.request_id !== this.currentRequestId) {
          console.error('Response manipulation detected: request_id mismatch');
          return { success: false };
        }

        const success = response.code?.toString() === "1";
        
        // Handle session token for all environments
        if (success && response.session_token) {
          console.log('[LoginModelNew] Received session token, setting cookie manually');
          document.cookie = `session_id=${response.session_token}; Path=/; Max-Age=3600; SameSite=Lax`;
          apiProxy.currentSessionToken = response.session_token;
        }
        
        // Server sets HttpOnly cookie automatically - no client-side storage needed
        return { success };
      } catch (error) {
        return { success: false };
      }
    },

    async verifyOTP(email, otp) {
      try {
        this.currentRequestId = this.generateRequestId();
        const response = await apiProxy.call("Central OTP Verify", {
          brand_id: normalizeBrandId(this.setbrandid),
          login_id: email,
          otp_code: otp,
          device_id: this.genHash(email),
          request_id: this.currentRequestId,
        });

        // Validate response matches request to prevent manipulation
        if (response.request_id !== this.currentRequestId) {
          console.error('Response manipulation detected: request_id mismatch');
          return { success: false };
        }

        const success = response.code?.toString() === "1";
        
        // Handle session token for all environments
        if (success && response.session_token) {
          console.log('[LoginModelNew] Received session token, setting cookie manually');
          document.cookie = `session_id=${response.session_token}; Path=/; Max-Age=3600; SameSite=Lax`;
          apiProxy.currentSessionToken = response.session_token;
        }
        
        // Server sets HttpOnly cookie automatically - no client-side storage needed
        return { success };
      } catch (error) {
        return { success: false };
      }
    },

    async createUserAccount() {
      try {
        const response = await apiProxy.call("Central User Registration", {
          firstname: this.firstname,
          surname: this.surname,
          email: this.email,
          termsAccepted: this.term_condition,
          emailConsent: this.email_consent,
          slug: normalizeBrandId(this.setbrandid),
        });

        return { success: response?.success };
      } catch (error) {
        this.showError(
          error.response?.data?.message || "Account creation failed"
        );
        return { success: false };
      }
    },

    async fetchUserDetails(email = null) {
      const response = await apiProxy.call(
        "Central User Details",
        email
          ? { slug: normalizeBrandId(this.setbrandid), email }
          : { slug: normalizeBrandId(this.setbrandid) }
      );

      return response;
    },

    updateUserData(userdata) {
      // UUID removed from sessionStorage for PCI compliance - handled server-side
      console.log('[LoginModelNew] Setting session_userdata:', userdata);
      encryptStorage.setItem("session_userdata", userdata);
      console.log('[LoginModelNew] Verified session_userdata set:', !!encryptStorage.getItem("session_userdata"));

      Object.entries({
        title: userdata.title,
        companyname: userdata.companyname || "",
        firstname: decodeURI(userdata.first_name),
        surname: decodeURI(userdata.last_name),
        email: userdata.email,
        email_consent_exists: userdata.email_consent,
        email_consent: userdata.email_consent,
        email_confirm: userdata.email,
        address: decodeURI(decodeURI(userdata.address_line_1)),
        address_line_2: decodeURI(decodeURI(userdata.address_line_2)),
        postcode: decodeURI(userdata.post_code),
        state: decodeURI(userdata.state),
        town: decodeURI(userdata.city),
        phonecode: userdata.phonecode,
        mobilenumber: userdata.mobilenumber,
      }).forEach(([key, value]) => (this[key] = value));

      // Trigger header update
      console.log('[LoginModelNew] Dispatching userLoggedIn event');
      window.dispatchEvent(new CustomEvent("userLoggedIn"));
    },

    async enw_log() {
      // Generate transaction token without UUID for security
      const chdata = process.env.VUE_APP_CHL + normalizeBrandId(this.setbrandid).toLowerCase();
      const hash = crypto.createHash("sha512");
      const transaction_token = hash.update(chdata, "utf-8").digest("hex");

      return apiProxy.call("Central Auth Log", {
        brand_id: normalizeBrandId(this.setbrandid).toLowerCase(),
        orderreference: this.orderreference || null,
        token: transaction_token,
        timestamp: Date.now(),
        // UUID removed - Central Lambda will inject server-side
      })
        .then((response) => {
          if (response?.user_exists === "Y" && response.data) {
            encryptStorage.setItem("enw_log_key", response.data);
            encryptStorage.setItem("mmb_link", response.mmb_link);
          }
          return response;
        })
        .catch((error) => {
          console.error("Authentication error", error);
          throw error;
        });
    },



    // Utility functions
    genHash(str) {
      let hash = 0;
      if (str.length === 0) return hash;
      for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }
      return hash;
    },

    generateRequestId() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2);
    },

    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },

    getLocalData(name) {
      if (name === "uuid") {
        return sessionStorage.getItem("uuid")?.replaceAll('"', "");
      }
      return JSON.parse(sessionStorage.getItem(name));
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: this.getrans(message),
        confirmButtonColor: "#034a94",
      });
    },

    async selectOtpMethod(method) {
      this.selectedOtpMethod = method;
      this.otpSentMethod = method;
      this.showOtpMethodSelection = false;
      
      if (method === 'sms') {
        await this.sendMobileOtp();
      } else {
        await this.sendOtp(this.pendingLoginData.email);
      }

      this.otp_panel_showing = true;
      this.loginSubmitting = false;

      // Initialize Web OTP for SMS
      if (method === "sms") {
        this.requestWebOtp();
        this.showCrossDeviceOption = !this.webOtpSupported;
      }
    },

    async sendPasskeyVerificationOtp() {
      if (!this.validateEmail('regUsername')) return;
      
      try {
        const response = await apiProxy.call("Central Passkey OTP Send", {
          email: this.regUsername,
          brand_id: normalizeBrandId(this.setbrandid),
        });

        if (response.success) {
          this.passkeyOtpSent = true;
          this.passkeySessionToken = response.session_token;
        } else {
          this.showError(response.message || "Failed to send verification code");
        }
      } catch (error) {
        this.showError("Failed to send verification code");
      }
    },

    async verifyPasskeyEmail() {
      if (!this.passkeyOtpCode) {
        this.showError("Please enter the verification code");
        return;
      }

      if (!this.passkeySessionToken) {
        this.showError("Session expired. Please request a new code.");
        return;
      }

      try {
        const response = await apiProxy.call("Central Passkey OTP Verify", {
          email: this.regUsername,
          brand_id: normalizeBrandId(this.setbrandid),
          otp_code: this.passkeyOtpCode,
          session_token: this.passkeySessionToken
        });

        if (response.success) {
          this.passkeyEmailVerified = true;
          this.passkeyOtpSent = false;
          this.passkeyOtpCode = "";
          this.passkeySessionToken = null;
        } else {
          this.showError(response.message || "Invalid verification code");
        }
      } catch (error) {
        this.showError("Verification failed");
      }
    },

    async sendLoginPasskeyVerificationOtp() {
      if (!this.validateEmail("loginemail")) return;

      try {
        const response = await apiProxy.call("Central Passkey OTP Send", {
          email: this.loginemail,
          brand_id: normalizeBrandId(this.setbrandid),
        });

        if (response.success) {
          this.passkeyOtpSent = true;
          this.passkeySessionToken = response.session_token;
        } else {
          this.showError(response.message || "Failed to send verification code");
        }
      } catch (error) {
        this.showError("Failed to send verification code");
      }
    },

    async verifyLoginPasskeyEmail() {
      if (!this.passkeyOtpCode) {
        this.showError("Please enter the verification code");
        return;
      }

      if (!this.passkeySessionToken) {
        this.showError("Session expired. Please request a new code.");
        return;
      }

      try {
        const response = await apiProxy.call("Central Passkey OTP Verify", {
          email: this.loginemail,
          brand_id: normalizeBrandId(this.setbrandid),
          otp_code: this.passkeyOtpCode,
          session_token: this.passkeySessionToken
        });

        if (response.success) {
          this.passkeyEmailVerified = true;
          this.passkeyOtpSent = false;
          this.passkeyOtpCode = "";
          this.passkeySessionToken = null;
        } else {
          this.showError(response.message || "Invalid verification code");
        }
      } catch (error) {
        this.showError("Verification failed");
      }
    },

    resetPasskeyVerification() {
      this.passkeyEmailVerified = false;
      this.passkeyOtpSent = false;
      this.passkeyOtpCode = "";
      this.passkeySessionToken = null;
    },
  },

  mounted() {
    this.modelShow = false;
    window.addEventListener(
      "loginModel",
      () => {
        this.modelShow = !this.modelShow;
      },
      false
    );

    // Check Web OTP support
    this.checkWebOtpSupport();

    // Handle deep link OTP
    // this.handleDeepLinkOtp();

    this.terms_and_conditions_link = this.brandText.terms_and_conditions_link;
    this.privacy_policy_link = this.brandText.privacy_policy_link;

    console.log('this.getransfn',this.getransfn);
  },

  beforeUnmount() {
    // Clean up Web OTP controller
    if (this.webOtpController) {
      this.webOtpController.abort();
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#login-model-wrapper {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .login-model {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.5);
    pointer-events: all;
    max-width: 600px;
    width: 100%;
    max-height: calc(100% - 2rem);
    overflow-y: auto;
    padding: 0;
    margin: 1rem;
    position: relative;

    @media screen and (max-width: 600px) {
      max-height: 100%;
      margin: 0rem;
    }

    h2 {
      margin-top: 0px;
      font-size: 1.2rem;
      font-weight: bold;
    }

    p,
    li {
      font-size: 1rem;
    }

    i.fa-times {
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 1rem;
      padding: 1rem;
      cursor: pointer;
      color: #fff;
    }
  }
}

.cross-device-option {
  text-align: center;
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  .cross-device-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.5rem auto 0;

    &:hover {
      background: #0056b3;
    }

    i {
      position: static;
      color: white;
    }
  }
}

.tab-buttons {
  display: flex;
  padding: 2rem 0 0rem;
  justify-content: space-evenly;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  color: #fff;
  font-weight: bold;
  div {
    padding: 1rem;
    position: relative;
    cursor: pointer;
    font-size: 2rem;
    text-align: center;
    opacity: 0.5;
    @media screen and (max-width: 576px) {
      font-size: 1.25rem;
    }
  }

  div.active {
    opacity: 1;
  }

  div.active:after {
    position: absolute;
    bottom: 0;
    height: 0;
    width: 0;
    left: 50%;
    transform: translate(-50%, 0.5rem);
    border: 22px solid transparent;
    border-bottom-color: #fff;
    content: "";
  }
}

.content {
  padding: 1rem 3rem;

  @media screen and (max-width: 600px) {
    padding: 1rem 1rem;
  }
}

.content-box {
  padding: 1rem;
  border: 1px solid #dfdfdf;
  background: #f7f7f7;
  border-radius: 4px;
  margin-bottom: 2rem;

  ul {
    margin: 0;
    padding: 0 0 0 1rem;
  }
}

h3 {
  font-size: 1.5rem;
  padding-bottom: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #dfdfdf;
}

button.proceed {
  position: relative;
  width: 100%;
  flex:1 ;
  padding: 1em 2rem;
  display: block;
  font-family: var(--details_buttons_loginmodal_font_family, inherit);
  font-size: var(--details_buttons_loginmodal_font_size, 1rem);
  font-weight: var(--details_buttons_loginmodal_font_weight, inherit);
  background: var(--details_buttons_loginmodal_background, #034a94);
  color: var(--details_buttons_loginmodal_font_color, #fff);
  border: var(--details_buttons_loginmodal_border, none);
  border-radius: var(--details_buttons_loginmodal_border_radius, 0.25rem);
}

.otp-method-selection {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  h4 {
    margin: 0 0 1rem 0;
    text-align: center;
  }

  .method-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;

    .method-btn {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 1.5rem;
      background: #007bff;
      color: white;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;

      &:hover {
        background: #0056b3;
      }

      i {
        position: static;
        color: white;
      }
    }
  }
}

.block {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
}

.block input:focus ~ label,
.block input:focus ~ label,
.block.hasValue label,
.block label,
.block label {
  top: 0px;
  font-size: 0.9rem !important;
  font-weight: bold;
  position: relative;
  padding: 0;
}

.block input,
.block select {
  border: 1px solid #dddddd !important;
  border-bottom: none;
  border-radius: 5px;
  font-weight: normal;
}

.block select {
  padding: 1.25rem 1rem;
  width: calc(100% - 2rem);
  box-sizing: initial;
  height: auto;
  min-height: 0px;
}

.block input {
  padding: 1.25rem 1rem;
}

.block select,
.block input {
  border: 1px solid #ddd;
  font-size: 1rem;
}

.error-message {
  color: #e00b27;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.block.error input {
  border-color: #e00b27 !important;
}

.login-buttons {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
}

.divider {
  text-align: center;
  margin: 1rem 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #ddd;
  }

  span {
    background: #fff;
    padding: 0 1rem;
    color: #666;
    font-size: 1rem;
    position: relative;
    z-index: 1;
  }
}

.registration-success {
  margin-top: 1rem;

  .success-message {
    text-align: center;
    padding: 1rem;
    background: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 0.5rem;
    margin-bottom: 1rem;

    i {
      color: #155724;
      font-size: 2rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    h4 {
      color: #155724;
      margin: 0.5rem 0;
    }

    p {
      color: #155724;
      margin: 0;
    }
  }
}

.login-registration-fallback {
  margin-top: 1rem;
  width: 100%;

  .info-message {
    text-align: center;
    padding: 1rem;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 0.5rem;
    margin-bottom: 1rem;

    i {
      color: #856404;
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    p {
      color: #856404;
      margin: 0;
    }
  }

  .back-to-login {
    width: auto;
    padding: 0.75rem;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 0.25rem;
    margin-top: 1rem;
    cursor: pointer;

    &:hover {
      background: #5a6268;
    }
  }
}

.input-checkbox {
  label {
    margin-top: 3px;
  }

  &.error {
    .checkmark-style {
      border-color: #e00b27 !important;
    }

    label {
      color: #e00b27;
    }
  }
}

label {
  cursor: default !important;
  font-size: 0.9rem;
  margin: 0;
}

.input-checkbox {
  margin: 1rem 0 0;
}

.block.tick:not(.ID-no-icons)::before,
.block.error:not(.ID-no-icons)::before {
  top: unset !important;
  bottom: 1.4rem !important;
  left: calc(100% - 2rem);
}

.email-verification {
  margin: 1rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;

  p {
    margin: 0 0 1rem 0;
    color: #495057;
  }

  .otp-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 1.2rem;
    letter-spacing: 0.2rem;
  }

  .verify-email-btn,
  .verify-code-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    width: 100%;

    &:hover {
      background: #0056b3;
    }
  }
}

.skip-passkey {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  width: 100%;
  margin-top: 1rem;

  &:hover {
    background: #5a6268;
  }
}

.verification-success {
  margin: 1rem 0;

  .success-message {
    text-align: center;
    padding: 1rem;
    background: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 0.5rem;

    i {
      color: #155724;
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      position: static;
    }

    p {
      color: #155724;
      margin: 0;
      font-weight: bold;
    }
  }
}
</style>

<style lang="scss">
.webauthn-register > button {
  position: relative;
  width: 100%;
  flex: 1;
  padding: 1em 2rem;
  display: block;
  margin-bottom: 1rem;
  
}
</style>
